/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import AdminLTE, {Sidebar, Navbar} from 'adminlte-2-react';
import './App.css';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Login, Logout} from './auth';
import {
  errorSelector,
  getDate,
  parseJwt,
  responseSelector,
} from './utils/utils';
import {
  duckUsuario,
  usuarioThunk,
  updateFirebaseTokenThunk,
} from './registro/duck';
import OlvidePass from './olvidePass/OlvidePass';
import ChangePassByToken from './olvidePass/ChangePassByToken';
import WithAuthV2 from './utils/WithAuthV2';

import {NotFound} from './utils/NotFound';

import {log} from './utils/utils';

import {
  messaging,
  getToken,
  onMessage,
  firebaseVapidKey,
} from './firebaseSetup';
import Landing from './landing/Landing';

import {ContactoCandidatos} from './candidatos/ContactoCandidatos';
import {ListaCandidatos} from './candidatos/ListaCandidatos';
import {ListaOportunidades} from './oportunidades/ListaOportunidades';
import {CrearOportunidad} from './oportunidades/CrearOportunidad';
import {EditarOportunidadV2} from './oportunidades/EditarOportunidadV2';
import {EditarDetallesOportunidad} from './oportunidades/EditarDetallesOportunidad';
import {CrearCandidato} from './candidatos/CrearCandidato';

import SubirImagenes from './imageUploadV3/SubirImagenes';
import CortarImagenesConcepto from './imageUploadV3/CortarImagenesConcepto';
import {EditarFotoCandidato} from './candidatos/EditarFotoCandidato';
import {EditarCandidato} from './candidatos/editar/EditarCandidato';
import {SubirArchivo} from './candidatos/archivo/SubirArchivo';
import {SubirOportFlyer} from './oportunidades/flyer/SubirOportFlyer';

import {ListaEmpresas} from './empresas/ListaEmpresas';
import {ListaInstitutos} from './institutos/ListaInstitutos';
import {CrearInstituto} from './institutos/CrearInstituto';
import {EditarInstituto} from './institutos/EditarInstituto';
import {CrearEmpresa} from './empresas/CrearEmpresa';
import {EditarEmpresa} from './empresas/EditarEmpresa';
import {ListaDatosAuxiliares} from './datosAuxiliares/ListaDatosAuxiliares';
import {ListaDatosGeografia} from './datosAuxiliares/ListaDatosGeografia';
import {ListaCandidatosNormalizar} from './candidatos/normalizacion/ListaCandidatosNormalizar';
import {NormalizarCandidato} from './candidatos/normalizacion/NormalizarCandidato';

import RegistroSuper from './registro/RegistroSuper';
import Confirmacion from './registro/Confirmacion';
import {CandidatoListaOportunidades} from './oportunidades/CandidatoListaOportunidades';
import Loader from './utils/Loader';

import {ReporteProduccionSelector} from './reportes/ReporteProduccionSelector';
import {ReporteProduccionSupervisor} from './reportes/ReporteProduccionSupervisor';
import {ReporteProduccionDetalle} from './reportes/ReporteProduccionDetalle';
import {SoloParaDemo} from './landing/SoloParaDemo';
import {ListaContactoMensajes} from './contactoMensajes/ListaContactoMensajes';
import {SubirOportRelevamiento} from './oportunidades/relevamiento/SubirOportRelevamiento';
import {CrearEstudioMercado} from './estudiosMercado/CrearEstudioMercado';
import {ListaEmCandidatos} from './estudiosMercado/candidatos/ListaEmCandidatos';
import {ListaEstudiosMercado} from './estudiosMercado/ListaEstudiosMercado';
import TabManager from './TabManager';
import {SidebarItem} from './utils/SidebarItem';
import {ModalGenerico} from './ui/ModalGenerico';

import UsuariosList from './usuarios/UsuariosList';

import {UsuarioEdit} from './usuarios/UsuarioEdit';
import {UsuarioAdd} from './usuarios/UsuarioAdd';
import {EquiposList} from './equipos/EquiposList';
import {EquipoCreate} from './equipos/EquipoCreate';
import {EquipoEdit} from './equipos/EquipoEdit';
import {ProduccionSelector} from './reportesv2/ProduccionSelector';

import {FeriadosList} from './feriados/FeriadosList';
import {FeriadoCreate} from './feriados/FeriadoCreate';
import {ProduccionFiltro} from './reportesv2/ProduccionFiltro';
import {ReporteEstado} from './reportesv2/ReporteEstado';
import {ReportesEnviadosList} from './reportesv2/ReportesEnviadosList';

import {ParametrosList} from './parametros/ParametrosList';
import {ParametroEdit} from './parametros/ParametroEdit';
import {Sincronizacion} from './reportesv2/Sincronizacion';
import {ChatSection} from './ia/ChatSection';

const lodash = require('lodash');

const {Entry} = Navbar;

const {Item} = Sidebar;

const MAX_PESTANAS = 10;

function App() {
  const dispatch = useDispatch();

  const [queryParams, setQueryParams] = useState({});
  const [queryParamsLoaded, setQueryParamsLoaded] = useState(false);
  const [isMaxTabsErrorShown, setIsMaxTabsErrorShown] = useState(false);

  const token = localStorage.getItem('token');
  const lfToken = localStorage.getItem('lfToken');
  const modelUsuario = useSelector(state => state.usuario);
  const [decodedToken, setDecodedToken] = useState(null);

  const [datosUsuario, setDatosUsuario] = useState({
    status: 'PENDING',
    data: null,
  });

  const [nombre, setNombre] = useState(null);
  const [candidatoId, setCandidatoId] = useState(null);
  const [actualRol, setActualRol] = useState(null);
  const [notificationPermission, setNotificationPermission] = useState(false);
  const [firebaseToken, setFirebaseToken] = useState({
    token: null,
    status: 'PENDING',
  });
  const [tabs, setTabs] = useState([]);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  const openIframe = ({
    e, // click event
    internalUrl, // url dentro de esta web app, se le agrega bandera "soyIframe"
    fullUrl, // url completa
    name,
  }) => {
    e.preventDefault();
    console.log('openIframe.internalUrl', internalUrl);
    const trucatedName = lodash.truncate(name, {length: 13});
    handleOpenTab(trucatedName, fullUrl ?? `${internalUrl}?soyIframe=yes`);
  };

  const handleOpenTab = (title, url) => {
    if (tabs.length >= MAX_PESTANAS) {
      setIsMaxTabsErrorShown(true);
      return;
    }

    // ts se usa como key para el tab
    const newTabs = [...tabs, {title, url, ts: Date.now()}];

    setTabs(newTabs);

    setCurrentTabIndex(newTabs.length - 1);
  };

  const handleCloseTab = index => {
    setTabs(tabs.filter((_, i) => i !== index));

    if (index === currentTabIndex) {
      const newTabIndex = Math.max(0, currentTabIndex - 1);
      setCurrentTabIndex(newTabIndex);

      if (tabs.length === 0) {
        setCurrentTabIndex(-1);
      }
    } else if (index < currentTabIndex) {
      setCurrentTabIndex(currentTabIndex - 1);
    }
  };

  const handleShowTab = index => {
    setCurrentTabIndex(index);
  };

  const [candidatoHistoryDeletionStatus, setCandidatoHistoryDeletionStatus] =
    useState('PENDING');

  useEffect(() => {
    if (queryParamsLoaded && queryParams.soyIframe === 'yes') {
      import('./ui/hideSidebarNHeader.css');
    }
  }, [queryParams, queryParamsLoaded]);

  const [alertSuscripcionLeida, setAlertSuscripcionLeida] = useState(false);

  const deletePreviousCandidatoHistory = () => {
    const rawCurrentCandidatosVistos = localStorage.getItem('candidatosVistos');

    const parsedCurrentCandidatosVistos = JSON.parse(
      rawCurrentCandidatosVistos,
    );

    const today = getDate();

    // loop through fields of parsed currentCandidatosVistos and delete
    // the ones that are not equal to today.
    for (const key in parsedCurrentCandidatosVistos) {
      if (key !== today) {
        delete parsedCurrentCandidatosVistos[key];
      }
    }

    localStorage.setItem(
      'candidatosVistos',
      JSON.stringify(parsedCurrentCandidatosVistos),
    );

    setCandidatoHistoryDeletionStatus('DONE');
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const queryParamsObj = {};
    for (let [key, value] of params.entries()) {
      queryParamsObj[key] = value;
    }
    setQueryParams(queryParamsObj);
    setQueryParamsLoaded(true);
  }, []);

  //TODO: cuando entro al home y no estoy logueado, regirigir a login
  useEffect(() => {
    if (token) {
      const decodedToken = parseJwt(token);
      setActualRol(decodedToken.rol);
      setDecodedToken(decodedToken);
      dispatch(usuarioThunk(decodedToken.id));
    }

    _checkAuth();

    deletePreviousCandidatoHistory();
  }, []);

  /**
   * Message listener while foreground
   */
  const onFirebaseMessageReceived = payload => {
    log('onMessage.payload');
    log(payload);

    // Mostrar notificacion

    new Notification(payload.notification.title, {
      body: payload.notification.body,
    });

    // Consultar cantidad de no leídos
  };

  const setUpNotifications = async () => {
    try {
      const currentToken = await getToken(messaging, {
        vapidKey: firebaseVapidKey,
      });

      if (!currentToken) {
        log('No registration token available');
        setFirebaseToken({token: null, status: 'ERROR'});
        return;
      }

      log('currentToken');
      log(currentToken);

      // Setear qué hacer cuando se recibe un mensaje en foreground

      onMessage(messaging, onFirebaseMessageReceived);

      setFirebaseToken({token: currentToken, status: 'LOADED'});
    } catch (error) {
      log('An error occurred while retrieving token. ');
      log(error);
      setFirebaseToken({token: null, status: 'ERROR'});
    }
  };

  useEffect(() => {
    if (notificationPermission) {
      setUpNotifications();
    }
  }, [notificationPermission]);

  useEffect(() => {
    const loginToken = token;
    if (loginToken && firebaseToken.token) {
      // Guardar token en tabla de usuario
      dispatch(
        updateFirebaseTokenThunk({
          firebaseToken: firebaseToken.token,
          userToken: loginToken,
        }),
      );
    }
  }, [firebaseToken]);

  function _checkAuth() {
    let authTokenCookieAuxi = document.cookie
      ? document.cookie.replace(
          /(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/,
          '$1',
        )
      : null;

    if (authTokenCookieAuxi) {
      localStorage.setItem('token', authTokenCookieAuxi);
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    const {data} = responseSelector(modelUsuario);
    const error = errorSelector(modelUsuario);

    if (error) {
      setNombre('N/A');
      dispatch(duckUsuario.actions.clear());
    }

    if (data) {
      setDatosUsuario({...datosUsuario, status: 'LOADED', data});
      const nombrePartido = data.nombre.split(' ');
      setCandidatoId(data.candidatoIdNumerico);
      setNombre(nombrePartido[0]);
      setAlertSuscripcionLeida(false);
      dispatch(duckUsuario.actions.clear());
    }
  }, [modelUsuario]);

  function sidebarUnlogged() {
    return [
      <Item
        key="bolsa-de-trabajo"
        text={
          <a href={`${process.env.REACT_APP_WEB_URL}/bolsa-de-trabajo.html`}>
            Bolsa de trabajo
          </a>
        }
      />,
    ];
  }

  function sidebarSuper() {
    return [<Item key="logout" text="Logout" to="/logout" />];
  }

  function sidebarCandidato() {
    return [
      <Item
        key="bolsa-de-trabajo"
        text={
          <a href={`${process.env.REACT_APP_WEB_URL}/bolsa-de-trabajo.html`}>
            Bolsa de trabajo
          </a>
        }
      />,
      <Item
        key="oportunidadesCandidato"
        text="Mis postulaciones"
        to={`/misOportunidades/${candidatoId}`}
      />,
      <Item
        key="editarCandidato"
        text="Mis datos"
        to={`/editarCandidato/${candidatoId}`}
      />,
      <Item key="logout" text="Logout" to="/logout" />,
    ];
  }

  function sidebarAdmin() {
    return [
      <SidebarItem
        icon="fa-user"
        key="candidatos"
        label="Candidatos"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/candidatos',
            name: 'Candidatos',
          })
        }
      />,

      <SidebarItem
        icon="fa-user"
        key="oportunidades"
        label="Oportunidades"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/oportunidades',
            name: 'Oportunidades',
          })
        }
      />,

      <SidebarItem
        icon="fa-user"
        key="empresas"
        label="Empresas"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/empresas',
            name: 'Empresas',
          })
        }
      />,

      <SidebarItem
        icon="fa-user"
        key="datosAuxiliares"
        label="Datos auxiliares"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/datosAuxiliares',
            name: 'Datos auxiliares',
          })
        }
      />,

      <SidebarItem
        icon="fa-user"
        key="datosGeograficos"
        label="Datos geográficos"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/datosGeograficos',
            name: 'Datos geográficos',
          })
        }
      />,

      <SidebarItem
        icon="fa-user"
        key="institutos"
        label="Institutos"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/institutos',
            name: 'Institutos',
          })
        }
      />,

      <SidebarItem
        icon="fa-user"
        key="candidatosActualizar"
        label="Candidatos a actualizar"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/candidatosActualizar',
            name: 'Cand. a actualizar',
          })
        }
      />,

      <SidebarItem
        icon="fa-user"
        key="usuariosLista"
        label="Usuarios"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/usuarios',
            name: 'Usuarios',
          })
        }
      />,

      <SidebarItem
        icon="fa-user"
        key="equiposLista"
        label="Equipos"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/equipos',
            name: 'Equipos',
          })
        }
      />,

      <SidebarItem
        icon="fa-user"
        key="parametrosLista"
        label="Parámetros producción"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/parametros',
            name: 'Parametros',
          })
        }
      />,

      <SidebarItem
        icon="fa-user"
        key="feriadosLista"
        label="Feriados"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/feriados',
            name: 'Feriados',
          })
        }
      />,

      <Item
        icon="fa-info"
        key="reportes"
        text="Reportes"
        children={[
          <SidebarItem
            key="estudioMercado"
            label="Estudio de Mercado"
            onClick={e =>
              openIframe({
                e,
                internalUrl: '/estudios',
                name: 'Est. de Mercado',
              })
            }
          />,
          <SidebarItem
            key="contactoCandidatos"
            label="Contacto candidatos"
            onClick={e =>
              openIframe({
                e,
                internalUrl: '/reportes/contactoCandidatos',
                name: 'Cont. candidatos',
              })
            }
          />,

          <SidebarItem
            key="produccionSelectorSupervisor"
            label="Producción"
            onClick={e =>
              openIframe({
                e,
                internalUrl: '/produccion/filtro',
                name: 'Producción',
              })
            }
          />,

          <SidebarItem
            key="reportesEnviados"
            label="Enviados"
            onClick={e =>
              openIframe({
                e,
                internalUrl: '/produccion/enviados',
                name: 'Enviados',
              })
            }
          />,

          <SidebarItem
            key="reporteEstado"
            label="Estado"
            onClick={e =>
              openIframe({
                e,
                internalUrl: '/reportes/estado',
                name: 'Estado',
              })
            }
          />,

          <SidebarItem
            key="sincronizacion"
            label="Sincronización"
            onClick={e =>
              openIframe({
                e,
                internalUrl: '/datos/sincronizacion',
                name: 'Sincronización',
              })
            }
          />,
        ]}
      />,

      <SidebarItem
        icon="fa-envelope"
        key="mensajes"
        label="Mensajes"
        onClick={e =>
          openIframe({
            e,
            internalUrl: '/mensajes',
            name: 'Mensajes',
          })
        }
      />,

      <li key="web" style={{}}>
        <a
          href={process.env.REACT_APP_WEB_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{width: '100%', cursor: 'pointer'}}>
          <FontAwesomeIcon
            color={null}
            icon="laptop-house"
            style={{marginRight: '6px'}}
          />{' '}
          <span>Web</span>
        </a>
      </li>,

      <Item key="logout" icon="fas-power-off" text="Logout" to="/logout" />,
    ];
  }

  //TODO: SideBar component separado que reciba rol y lo que necesite
  function _buildSidebar(rol) {
    switch (rol) {
      case 'superadmin':
        return sidebarSuper();
      case 'admin':
        return sidebarAdmin();
      case 'selector':
        return sidebarAdmin();
      case 'candidato':
        return sidebarCandidato();
      default:
        return sidebarUnlogged();
    }
  }

  function renderNavBar() {
    return (
      <Navbar.Core>
        <li className="navbar-menu">
          <a style={{cursor: 'pointer'}} className="nav-link">
            {nombre?.length > 30 ? `${nombre.substring(0, 30)}...` : nombre}
          </a>
        </li>
        <Entry
          icon="fas-power-off"
          onClick={() => window.location.replace('/logout')}
        />
      </Navbar.Core>
    );
  }

  if (candidatoHistoryDeletionStatus !== 'DONE') {
    return <Loader isLoading={true}>{null}</Loader>;
  }

  if (!queryParamsLoaded) {
    return <Loader isLoading />;
  }

  if (queryParamsLoaded && queryParams.soyIframe !== 'yes') {
    console.log('App.render.currentTabIndex', currentTabIndex);
  }

  return (
    <React.Fragment>
      <ModalGenerico
        isModalShown={isMaxTabsErrorShown}
        hideModal={() => setIsMaxTabsErrorShown(false)}
        title="Máximo de pestañas"
        body={`Se pueden abrir hasta ${MAX_PESTANAS} pestañas. Por favor, cierre alguna para abrir nuevas.`}
        buttonText="Aceptar"
        submit={() => {
          setIsMaxTabsErrorShown(false);
        }}
      />
      <AdminLTE
        title={['INCENTIVA']}
        titleShort={['I']}
        theme="yellow-light"
        sidebar={_buildSidebar(actualRol)}
        homeTo={
          actualRol === 'admin' || actualRol === 'selector' ? 'adm' : '/'
        }>
        {token ? renderNavBar() : <React.Fragment />}

        <WithAuthV2
          path="/adm"
          children={TabManager}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
          additionalProps={{
            tabs: tabs,
            setTabs: setTabs,
            handleCloseTab: handleCloseTab,
            currentTabIndex: currentTabIndex,
            handleShowTab: handleShowTab,
          }}
        />

        <RegistroSuper path="/registro" />

        <Confirmacion path="/register/:invitacionId" />

        <ChangePassByToken path="/changePass/:resetToken" />

        <OlvidePass path="/recuperarPassword" />

        <Login path="/login" firebaseToken={firebaseToken} />

        <Logout path="/logout" />

        <WithAuthV2
          path="/candidatos"
          children={ListaCandidatos}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/reportes/contactoCandidatos"
          children={ContactoCandidatos}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/empresas"
          children={ListaEmpresas}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/oportunidades"
          children={ListaOportunidades}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/misOportunidades/:candidatoId"
          children={CandidatoListaOportunidades}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/crearOportunidad"
          children={CrearOportunidad}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/editarOportunidad/:oportunidadId"
          children={EditarOportunidadV2}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/editarDetalleOportunidad/:oportunidadId"
          children={EditarDetallesOportunidad}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/crearCandidato"
          children={CrearCandidato}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/editarCandidato/:candidatoId"
          children={EditarCandidato}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/editarFotoCandidato/:candidatoId"
          children={EditarFotoCandidato}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/subirImagenes"
          children={SubirImagenes}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          path="/cortarImagenes"
          children={CortarImagenesConcepto}
          datosUsuario={datosUsuario}
          allowWithoutOnboarding={true}
        />

        <WithAuthV2
          exact
          path="/landing"
          children={Landing}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/candidato/archivo/:candidatoId"
          children={SubirArchivo}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/oportunidad/flyer/:oportunidadId"
          children={SubirOportFlyer}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/oportunidad/relevamiento/:oportunidadId"
          children={SubirOportRelevamiento}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/institutos"
          children={ListaInstitutos}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/instituto/agregar"
          children={CrearInstituto}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/instituto/editar/:institutoId"
          children={EditarInstituto}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/empresa/agregar"
          children={CrearEmpresa}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/empresa/editar/:empresaId"
          children={EditarEmpresa}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/datosAuxiliares"
          children={ListaDatosAuxiliares}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/datosGeograficos"
          children={ListaDatosGeografia}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/candidatosActualizar"
          children={ListaCandidatosNormalizar}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/actualizarCandidato/:candidatoId"
          children={NormalizarCandidato}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/reporte/produccion/selector"
          children={ReporteProduccionSelector}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/reporte/produccion/supervisor"
          children={ReporteProduccionSupervisor}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/reporte/produccion/detalle"
          children={ReporteProduccionDetalle}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/mensajes"
          children={ListaContactoMensajes}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/soloParaDemo"
          children={SoloParaDemo}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/estudio/crear"
          children={CrearEstudioMercado}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/estudio/:estudioMercadoIdNumerico"
          children={ListaEmCandidatos}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/estudios"
          children={ListaEstudiosMercado}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/usuario/agregar"
          children={UsuarioAdd}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/usuario/editar/:credencialId"
          children={UsuarioEdit}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/usuarios"
          children={UsuariosList}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/equipos"
          children={EquiposList}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/parametros"
          children={ParametrosList}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/feriados"
          children={FeriadosList}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/equipo/crear"
          children={EquipoCreate}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/feriado/crear"
          children={FeriadoCreate}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/equipo/editar/:equipoId"
          children={EquipoEdit}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/parametro/editar/:id"
          children={ParametroEdit}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/produccion/selector"
          children={ProduccionSelector}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/produccion/filtro"
          children={ProduccionFiltro}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/reportes/estado"
          children={ReporteEstado}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/datos/sincronizacion"
          children={Sincronizacion}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/produccion/enviados"
          children={ReportesEnviadosList}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <WithAuthV2
          exact
          path="/"
          children={Landing}
          allowWithoutOnboarding={true}
          datosUsuario={datosUsuario}
        />

        <NotFound path="*" />
      </AdminLTE>

      <ChatSection
        queryParamsLoaded={queryParamsLoaded}
        queryParams={queryParams}
        lfToken={lfToken}
        decodedToken={decodedToken}
      />
    </React.Fragment>
  );
}

export default App;
